import React from 'react'
import { Link } from 'react-router-dom'

import { Container, ButtonsWrapper } from './styles'

import LogoDirecaoWhiteSVG from '../../../../assets/logos/LogosBlackAndWhite/LogoDirecaoWhite_2023.svg'
import LogoDirecaoBlackSVG from '../../../../assets/logos/LogosBlackAndWhite/LogoDirecaoBlack_2023.svg'
import Img from 'react-webp-image'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../store/modules/rootReducer'
import HeaderOptions from '../../../../components/HeaderOptions'
import RoutesDropdown from '../RoutesDropdown'
import { setState } from '../../../../types/setState'

interface IProps {
  setHeaderHeight?: setState<number>
  onRoutesDropdownClick?(): void
}

const Header: React.FC<IProps> = (props) => {
  const { isDarkMode } = useSelector((state: RootState) => state.theme)

  const onRender = (node: HTMLDivElement | null) => {
    if (!node) return

    if (props.setHeaderHeight) props.setHeaderHeight(node.clientHeight)
  }

  return (
    <Container ref={onRender}>
      <div className="header">
        <ButtonsWrapper>
          <RoutesDropdown onClick={props.onRoutesDropdownClick} />

          <Link to="/">
            <Img
              src={isDarkMode ? LogoDirecaoBlackSVG : LogoDirecaoWhiteSVG}
              alt="Direção Concursos"
              className="logoDirecao"
            />
          </Link>
          <HeaderOptions className="headerOptions" />
        </ButtonsWrapper>
      </div>
      <hr />
    </Container>
  )
}

export default Header
